import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-add-marketplace',
  templateUrl: './add-marketplace.component.html',
  styleUrls: ['./add-marketplace.component.css']
})
export class AddMarketplaceComponent implements OnInit {

  form: FormGroup;
  businessID = this.route.snapshot.params.businessID;
  mdGroups = [];
  subGroups = [];
  selectedSubtypes = [];
  company;
  authToken = localStorage.getItem('auth');
  showLogoErr = false;
  messageErr;
  btnText = 'Lisää ilmoitus';
  marketplaceID = this.route.snapshot.params.marketplaceID;
  selectedMDSubtype;
  wellfareAreas = [];
  selectedMDType;
  opening;
  prices = [];
  current_price = 0;
  charLen = 0;

  constructor( 
    private fb: FormBuilder,
    private router: Router,
    private http: HttpClient,
    private route:ActivatedRoute,
    private authService: AuthService) { }

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}` }),
    withCredentials: true,
  };

  get description() { return this.form.get('description') };
  get title() { return this.form.get('title') };
  get area() { return this.form.get('area') };

  ngOnInit(): void {
    this.fetchMDParams();
    this.getBusinessDetails();
    this.fetchWellfareAreas();
    this.fetchPrices();

    this.form = this.fb.group({


      description: ['', Validators.required],
      title: ['', Validators.required],
      area: ['', Validators.required],

    });

    if(this.marketplaceID){
      this.btnText = 'Muokkaa ilmoitusta';
      this.fetchMarketplace();
    }


  }

  fetchMarketplace() {
    this.http.get(environment.MARKET_PLACE_OFFER + '/'+this.marketplaceID, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          this.opening = res.message;
          //Set form values
          this.description.setValue(this.opening.description);
          this.title.setValue(this.opening.title);
          this.selectedMDType = this.opening.mdType;
          if(this.opening.mdSubType){
            this.selectedMDSubtype = this.opening.mdSubType;
          }
          
          setTimeout(() => {
          this.area.setValue(this.opening.area);
          (<HTMLSelectElement>document.getElementById('md-type')).value = this.opening.mdType.id;
          },300)

        }
        else {
          console.log('buu')
          this.opening;
        }
        
      }, (err: any) => {

      }
    )
  }

  fetchPrices(){
    this.http.get(environment.EMPLOYER_PRICING, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          console.log(res.message);
          this.prices = res.message;
          console.log(this.prices)
          if(this.prices['marketplace']['leave'].price && this.prices['marketplace']['leave'].price > 0){
            this.current_price = this.prices['marketplace']['leave'].price;
          }

        }
        else {
          this.prices = [];
        }
        
      }, (err: any) => {

      }
    )
  }

  fetchWellfareAreas() {
    this.http.get(environment.PARAMS_WELLFAREAREAS, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          this.wellfareAreas = res.message['wellfare-areas'];
          console.log(this.wellfareAreas)

        }
        else {
          this.wellfareAreas = [];
        }
        
      }, (err: any) => {

      }
    )
  }

  getBusinessDetails() {

    this.http.get(environment.USER_BUSINESS, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          this.company = res.message[0];

          if(!this.company.logo){
            this.showLogoErr = true;
          }


        }
        else {
          var anElm = document.getElementById('notadded');
          anElm.style.display="block";
          console.log('ei ole kyseistä käyttäjää')
        }
        
      }, (err: any) => {
  
        console.log("Error while finding status :: ", err);
      })


  }

  fetchMDParams() {
    this.http.get(environment.PARAMS_MD_TYPES, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          console.log(res.message);
          this.mdGroups = res.message['md-types'];
          console.log(this.mdGroups)

        }
        else {
          var anElm = document.getElementById('notadded');
          anElm.style.display="block";
          console.log('ei ole kyseistä käyttäjää')
        }
        
      }, (err: any) => {
  
        console.log("Error while finding status :: ", err);
      })
  }

  areaSelected(e){

  }

  mdtypeSelected(e) {
    //get the value of selected option
    this.selectedMDSubtype = null;
    var mdid = e.target.id;
    console.log(mdid)
    var mdType = (<HTMLInputElement>document.getElementById(mdid)).value;
    //Clear md-sub-type
    if(document.getElementById('md-sub-type')){
      (<HTMLSelectElement>document.getElementById('md-sub-type')).value = "";
    }
    console.log(mdType)
    var btn = document.getElementById('open-subtypes');
    for (let i = 0; i < this.mdGroups.length; i++) {
      var group = this.mdGroups[i];

      console.log(group.id, mdType)

      if(group.id == mdType){
        this.selectedSubtypes = group.subtypes;
        this.selectedMDType = group;
        console.log('Selected MD type: ', this.selectedMDType.work_possibilities)
        break;
      }
     
    }
/*     if(this.selectedSubtypes.length > 0){
      btn.click();
    } */
  }

  selectSubtype(){
    var elm = (<HTMLInputElement>document.getElementById('md-sub-type')).value;
    for (let i = 0; i < this.selectedSubtypes.length; i++) {
      const el = this.selectedSubtypes[i];

      if(el.id == elm){
        this.selectedMDSubtype = el;
        break;
      }
      
    }
  }

  onSubmit(){

    if(this.marketplaceID){
      this.editMarketplace();
    }
    else{
      this.addMarketplace();
    }
  }

  editMarketplace() {
    var area_data = {};
    if(!this.selectedMDType){
      alert('Valitse ala')
      return;
    }

    for (let i = 0; i < this.wellfareAreas.length; i++) {
      const elm = this.wellfareAreas[i];
      var id = elm.id;
      if(elm.id == this.area.value){
        area_data = elm;
        break;
      }
    }
    //title max 50
    if(this.title.value.length > 50){
      alert('Otsikko saa olla maksimissaan 50 merkkiä pitkä')
      return;
    }



    var req = {
      title: this.title.value,
      description: this.description.value,
      mdType: this.selectedMDType,
      mdSubType: this.selectedMDSubtype,
      area: this.area.value,
      logo: this.company.logo,
      businessName: this.company.businessName,
      marketplaceID: this.marketplaceID,
    }

    console.log(req);

    this.http.put(environment.MARKET_PLACE, req, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          console.log(res.message)
          this.router.navigate(['/'+this.businessID + '/marketplaces/marketplace/single-marketplace/own/' + this.marketplaceID])
        }
        else {
          alert('Virhe muokattaessa ilmoitusta')
        }
        
      }
    )


  }

  addMarketplace() {

    var area_data = {};

    //Check that md type is selected

    if(!this.selectedMDType){
      alert('Valitse ala')
      return;
    }

    for (let i = 0; i < this.wellfareAreas.length; i++) {
      const elm = this.wellfareAreas[i];
      var id = elm.id;
      if(elm.id == this.area.value){
        area_data = elm;
        break;
      }
    }
    //title max 50
    if(this.title.value.length > 50){
      alert('Otsikko saa olla maksimissaan 50 merkkiä pitkä')
      return;
    }



    var req = {
      title: this.title.value,
      description: this.description.value,
      mdType: this.selectedMDType,
      mdSubType: this.selectedMDSubtype,
      area: this.area.value,
      logo: this.company.logo,
      businessName: this.company.businessName,
    }

    console.log(req);

    this.http.post(environment.MARKET_PLACE, req, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          console.log(res.message)
          this.router.navigate(['/'+this.businessID + '/marketplace'])
        }
        else {
          console.log('buu')
        }
        
      }
    )



  }
  
  addMarketPlace(){
    //Check if area and mdType is selected

    if(!this.selectedMDType){
      alert('Valitse ala')
      return;
    }

  }

  goBack(){
      window.history.back();
  }
  countChars(){
    var title = this.title.value;
    this.charLen = title.length;

  }

}
